var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { Box, TextField } from '@mui/material';
import theme from '../../Theming/DefaultTheme';
import { AppConfig } from '../../../app.config';
var container = {
    display: 'flex',
    justifyContent: 'center',
    gap: 6,
    backgroundColor: 'transparent',
};
var codeInput = {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    width: 60,
    boxShadow: '0px 0px 5px rgba(0,0,0,0.2)',
};
var CodeInput = function (_a) {
    var codeLength = _a.codeLength, onComplete = _a.onComplete;
    var defaultMapCode = AppConfig.environment == 'development' ? ['J', 'D', '6', '3', 'F'] : [];
    var _b = useState(defaultMapCode), code = _b[0], setCode = _b[1];
    var inputRefs = useRef([]);
    var handleChange = function (value, index) {
        var _a;
        var newCode = __spreadArray([], code, true);
        newCode[index] = value;
        setCode(newCode);
        // Move to the next input field if the current one is filled
        if (value && index < codeLength - 1) {
            (_a = inputRefs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // Call onComplete if all fields are filled
        if (newCode.every(function (char) { return char !== ''; })) {
            onComplete(newCode.join(''));
        }
    };
    var handleKeyDown = function (event, index) {
        var _a;
        if (event.key === 'Backspace' && !code[index] && index > 0) {
            (_a = inputRefs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (_jsx(Box, { style: container, children: Array.from({ length: codeLength }).map(function (_, index) { return (_jsx(TextField, { value: code[index], inputRef: function (el) { return (inputRefs.current[index] = el); }, onChange: function (event) { return handleChange(event.target.value, index); }, onKeyDown: function (event) { return handleKeyDown(event, index); }, style: codeInput, slotProps: {
                htmlInput: {
                    maxLength: 1,
                    style: {
                        fontSize: 24,
                        fontWeight: 500,
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: theme.palette.text.primary,
                    },
                },
            } }, index)); }) }));
};
export default CodeInput;
